import React from "react";

const sizeByAs = {
  h1: "text-3xl md:text-4xl",   // was likely too big before
  h2: "text-2xl md:text-3xl",
  h3: "text-xl md:text-2xl",
  h4: "text-lg md:text-xl",
  h5: "text-base md:text-lg",
  h6: "text-base",
  p:  "text-base",
};

function Heading({ as: Tag = "h3", className = "", children, ...props }) {
  const base =
    "font-semibold leading-snug tracking-tight text-gray-900";
  const size = sizeByAs[Tag] || sizeByAs.h2;

  return (
    <Tag className={`${base} ${size} ${className}`} {...props}>
      {children}
    </Tag>
  );
}

export default Heading;
